/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Collections_TitleInputs */



/**
* | output |
* | --- |
* | "Managing Your Collection" |
*
* @param {Help_Article_Collections_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_collections_title = /** @type {((inputs?: Help_Article_Collections_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Collections_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deine Sammlung verwalten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gérer votre collection")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("管理你的收藏")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("管理你的收藏")
	if (locale === "ko") return /** @type {LocalizedString} */ ("컬렉션 관리하기")
	return /** @type {LocalizedString} */ ("Managing Your Collection")
});